// src/core/constants.js

// ===============================
// User Roles
// ===============================
export const ROLES = {
  ADMIN: "admin",
  STUDENT: "student",
};

// ===============================
// Order Status
// ===============================
export const ORDER_STATUS = {
  PENDING: "pending",
  PAID: "paid",
  FAILED: "failed",
  CANCELLED: "cancelled",
};

// ===============================
// Payment Status
// ===============================
export const PAYMENT_STATUS = {
  INITIATED: "initiated",
  SUCCESS: "success",
  ERROR: "error",
};

// ===============================
// Cart
// ===============================
export const CART_CONSTANTS = {
  STORAGE_KEY: "app_cart",
  MAX_ITEMS: 20,
};

// ===============================
// Authentication
// ===============================
export const AUTH_CONSTANTS = {
  TOKEN_STORAGE_KEY: "app_access_token",
  REFRESH_TOKEN_KEY: "app_refresh_token",
  USER_STORAGE_KEY: "app_user",
};

// ===============================
// Application
// ===============================
export const APP_CONSTANTS = {
  APP_NAME: "EduPlatform",
  CURRENCY: "ZAR",
  DATE_FORMAT: "YYYY-MM-DD",
};

// ===============================
// Google OAuth Scopes (Reference)
// ===============================
export const GOOGLE_SCOPES = {
  OPENID: "openid",
  EMAIL: "email",
  PROFILE: "profile",
  SHEETS: "https://www.googleapis.com/auth/spreadsheets",
};

// ===============================
// src/core/constants.js
// ===============================
export const SHEET_KEYS = {
  BOOKS: 'BooksSheetIdHere',
  CLASSES: 'ClassesSheetIdHere',
  CART: 'CartSheetIdHere',
  ORDERS: 'OrdersSheetIdHere',
  // add others as needed
};